// extracted by mini-css-extract-plugin
module.exports = {"DeleteButton":"Uf-GfKXYOjhFEW9rOuCujw=="};